import React, { useState } from "react";
import { useOutletContext } from "react-router-dom";
import WpTitle from "../../../components/WriteProject/WpTitle/WpTitle";
import { ProjectType } from "../../../interface/interface";

const Step5 = () => {
  const {
    state: { pnlt_lst },
    UpdateCommon,
  }: {
    state: ProjectType;
    UpdateCommon: (
      type: string,
      payload: string | number,
      index: number | undefined
    ) => void;
  } = useOutletContext();
  const [text, setText] = useState<string>("");

  return (
    <div className="step5">
      <WpTitle title="패널티 및 강퇴조건" />
      <div className="box-wrapper">
        <div className="insert-wrapper">
          <div className="input-wrapper">
            <input
              type="text"
              maxLength={20}
              placeholder="패널티 및 강퇴조건 입력"
              value={text}
              onChange={(e) => {
                setText(e.target.value);
              }}
            />
            <div className="input-length">{text.length}/20</div>
          </div>
          <button
            className="text-init-btn"
            onClick={() => {
              setText("");
              UpdateCommon("pnlt/add", text, undefined);
            }}
          >
            등록하기
          </button>
        </div>
        <div className="penalty-list">
          <div className="list-wrapper">
            {pnlt_lst.map((item, idx) => {
              return (
                <div key={idx} className="panalty-card">
                  <div className="title">{item.bnfit_nm}</div>
                  <img
                    src="/assets/editor/blue-cancel.svg"
                    alt=""
                    onClick={() => {
                      UpdateCommon("pnlt/remove", "", idx);
                    }}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step5;
